export default __webpack_public_path__ + "media/empowerment.d73bf309.png";